<template>
  <div class="loader">
    <img class="loader__img" src="@/assets/img/loader.png" alt="Carregando..."/>
  </div>
</template>
<script>
export default {
  name: 'Loader'
}
</script>

<style scoped lang="scss">
.loader {
  align-items: center;
  background-color: rgba(255,255,255, .95);
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;

  &__img {
    animation: spin 1s ease .5s infinite;
    animation-duration: .7s;
    height: 48px;
  }
}

@keyframes spin {
  from {
    transform:rotate(0deg);
  }

  to {
    transform:rotate(360deg);
  }
}
</style>
